import React, { useState, useEffect } from 'react';
import moment from 'moment';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { graphChangeLoading } from 'modules/filter';
import {
  makeRowColumn,
  getHeadObj,
  cenversionTpCode,
  getDate,
} from 'lib/commonLib';
import { localReport } from 'lib/api/localreport';

import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';

import LocalStatisticsGraph from './LocalStatisticsGraph';

const LocalStatistics = ({ location }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isPopPage = queryString.parse(location.search).isPop === '1';

  const initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    sumSub: 1,
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: getDate(moment()),
  };
  const [params, setParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const customized = {
    ADSTRD_NM: {
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'ADSTRD_NM');
        return !!rowObj['PLTFOM_TP_CODE']
          ? cenversionTpCode(rowObj.PLTFOM_TP_CODE)
          : makeRowColumn(
              rowObj['ADSTRD_NM'],
              statsDttm.type,
              statsDttm.format
            );
      },
    },

    ADSTRD_CODE: { merged: true },
    UM_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return t('성향');
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'UM_PAR_EPRS_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'UM_PAR_EPRS_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['UM_PAR_EPRS_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            {!!rowObj['UM_PAR_EPRS_RATE'] && !rowObj['isChild'] && (
              <>
                {' '}
                (
                {makeRowColumn(
                  rowObj['UM_PAR_EPRS_RATE'],
                  bodyItem2.type,
                  bodyItem2.format
                )}
                )
              </>
            )}
          </>
        );
      },
    },
    UM_PAR_EPRS_RATE: { merged: true },
    AD_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return t('베이스광고');
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'AD_PAR_EPRS_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'AD_PAR_EPRS_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['AD_PAR_EPRS_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            {!!rowObj['AD_PAR_EPRS_RATE'] && !rowObj['isChild'] && (
              <>
                {' '}
                (
                {makeRowColumn(
                  rowObj['AD_PAR_EPRS_RATE'],
                  bodyItem2.type,
                  bodyItem2.format
                )}
                )
              </>
            )}
          </>
        );
      },
    },
    AD_PAR_EPRS_RATE: { merged: true },
    MEDIA_SCRIPT_CNT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'MEDIA_SCRIPT_CNT');
        return (
          rowObj['ADSTRD_NM'] !== 'total' &&
          !rowObj['isChild'] &&
          makeRowColumn(
            rowObj['MEDIA_SCRIPT_CNT'],
            bodyItem1.type,
            bodyItem1.format
          )
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      if (isPopPage && window.location.search !== '?isPop=1') {
        window.location.replace(window.location.pathname + '?isPop=1');
      }
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleGraphLoading = (state) => {
    dispatch(graphChangeLoading(state));
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <LocalStatisticsGraph
        params={params}
        handleGraphLoading={handleGraphLoading}
      />
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={localReport}
        customized={customized}
        expandTable
        useFetch={false}
      />
    </>
  );
};

export default withRouter(LocalStatistics);
